/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/require-default-props */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable array-callback-return */
import styled from '@emotion/styled';
import {
	ArrowBack,
	ArrowForward,
	CheckCircle,
	Pending,
	Timelapse,
} from '@mui/icons-material';
import { Box, Button, Paper, Step, StepLabel, Stepper } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import OrdersContext from '../../Context/Orders/OrdersContext';

export default function StatusStepperCard({ status, id }) {
	const { setOrderStatus } = useContext(OrdersContext);
	const [currentStep, setCurrentStep] = useState();

	useEffect(() => {
		if (status === 'pending') setCurrentStep(0);
		if (status === 'inProgress') setCurrentStep(1);
		if (status === 'done') setCurrentStep(2);
	}, []);
	const steps = ['Pendiente', 'En proceso', 'Finalizado'];

	const ColorlibStepIconRoot = styled('div')(({ ownerState }) => ({
		backgroundColor: '#fff',
		zIndex: 1,
		color: '#fff',

		display: 'flex',
		borderRadius: '50%',
		justifyContent: 'center',
		alignItems: 'center',
		...(ownerState.active && {
			backgroundColor: '#fff',
			boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
		}),
		...(ownerState.completed && {
			backgroundColor: '#fff',
		}),
	}));

	// eslint-disable-next-line react/no-unstable-nested-components
	function ColorlibStepIcon(props) {
		const { active, completed, className } = props;

		const icons = {
			1: (
				<Pending fontSize='large' sx={{ margin: '0 auto', color: '#FFD600' }} />
			),
			2: (
				<Timelapse
					fontSize='large'
					sx={{ margin: '0 auto', color: '#1261BF' }}
				/>
			),
			3: (
				<CheckCircle
					fontSize='large'
					sx={{ margin: '0 auto', color: '#04BE00' }}
				/>
			),
		};
		const icons2 = {
			1: (
				<Pending fontSize='large' sx={{ margin: '0 auto', color: '#c9c9c9' }} />
			),
			2: (
				<Timelapse
					fontSize='large'
					sx={{ margin: '0 auto', color: '#c9c9c9' }}
				/>
			),
			3: (
				<CheckCircle
					fontSize='large'
					sx={{ margin: '0 auto', color: '#c9c9c9' }}
				/>
			),
		};

		return (
			<ColorlibStepIconRoot
				ownerState={{ completed, active }}
				className={className}
			>
				{completed || active
					? icons[String(props.icon)]
					: icons2[String(props.icon)]}
			</ColorlibStepIconRoot>
		);
	}

	ColorlibStepIcon.propTypes = {
		/**
		 * Whether this step is active.
		 * @default false
		 */
		active: PropTypes.bool,
		className: PropTypes.string,
		/**
		 * Mark the step as completed. Is passed to child components.
		 * @default false
		 */
		completed: PropTypes.bool,
		/**
		 * The label displayed in the step icon.
		 */
		icon: PropTypes.node,
	};

	return (
		<Paper
			elevation={3}
			sx={{
				width: '100%',
				backgroundColor: 'white.main',
				borderRadius: '8px',
				padding: '8px',
			}}
		>
			<Stepper activeStep={currentStep} alternativeLabel>
				{steps.map((label) => (
					<Step key={label}>
						<StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
					</Step>
				))}
			</Stepper>
			<Box
				sx={{
					width: '100%',
					display: 'flex',
					justifyContent: 'space-between',
					marginTop: '8px',
				}}
			>
				<Button
					disabled={currentStep === 0}
					onClick={() => {
						if (currentStep !== 0) {
							setCurrentStep(currentStep - 1);
							if (currentStep === 1) {
								setOrderStatus(id, 'pending');
							}
							if (currentStep === 2) {
								setOrderStatus(id, 'inProgress');
							}
						}
					}}
					variant='contained'
					startIcon={<ArrowBack />}
				>
					Atrasar
				</Button>
				<Button
					disabled={currentStep === 2}
					onClick={() => {
						if (currentStep !== 2) {
							if (currentStep === 0) {
								setOrderStatus(id, 'inProgress');
								setCurrentStep(currentStep + 1);
							}
							if (currentStep === 1) {
								Swal.fire({
									width: 400,
									title: 'Finalizar pedido?',
									text: 'El pedido se movera al apartado de pedidos finalizados.',
									icon: 'question',
									showCancelButton: true,
									confirmButtonColor: '#04BE00',
									cancelButtonColor: '#3085d6',
									confirmButtonText: 'Finalizar',
									cancelButtonText: 'Cancelar',
									customClass: {
										container: 'my-swal',
									},
								}).then((result) => {
									if (result.isConfirmed) {
										setOrderStatus(id, 'done');
										setCurrentStep(currentStep + 1);
									}
								});
							}
						}
					}}
					variant='contained'
					endIcon={<ArrowForward />}
				>
					{currentStep >= 1 ? 'Finalizar' : 'Avanzar'}
				</Button>
			</Box>
		</Paper>
	);
}
